export enum AppPage {
  LandingPage = "LandingPage",
  AboutLandingPage = "aboutLandingPage",
  AboutDigitalSigning = "aboutDigitalSigning",
  AboutFaq = "aboutFaq",
  AboutPrivacy = "aboutPrivacy",
  AboutTerms = "aboutTerms",
  Create = "create",
  Split = "split",
  Invitation = "invitation",
  Report = "report",
  ReportLoginCallback = "reportLoginCallback",
  ReportForm = "reportForm",
  ReportFormAccidentDescription = "reportFormAccidentDescription",
  ReportFormVehicle = "reportFormVehicle",
  ReportFormDriver = "reportFormDriver",
  ReportFormInsurance = "reportFormInsurance",
  ReportFormAccident = "reportFormAccident",
  ReportFormSketch = "reportFormSketch",
  ReportFormAttachments = "reportFormAttachments",
  ReportFormWitness = "reportFormWitness",
  ReportPreview = "reportPreview",
  ReportSign = "reportSign",
  ReportSignCallback = "reportSignCallback",
  ReportStatus = "reportStatus",
  ReportConfirmation = "reportConfirmation",
  ReportPageTwoSupplementalInfo = "reportPageTwoSupplementalInfo",
  ReportPageTwoAccidentDescription = "reportPageTwoAccidentDescription",
  ReportPageTwoInjury = "reportPageTwoInjury",
}
